var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalPod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.492,
    height: 32,
    viewBox: "0 0 28.492 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_POD",
    "data-name": "Total POD",
    transform: "translate(-179.262 -155.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M433.788,467.322l-3.06,3.96-1.343-1.261a.75.75,0,0,0-1.027,1.094l1.945,1.826a.75.75,0,0,0,.514.2l.06,0a.75.75,0,0,0,.534-.289l3.565-4.613a.75.75,0,0,0-1.188-.917Z",
    transform: "translate(-230.84 -289.394)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M342.976,322.88H330.331a.75.75,0,1,0,0,1.5h12.645a.75.75,0,1,0,0-1.5Z",
    transform: "translate(-139.434 -155.681)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M422.079,370.24h-6.47a.75.75,0,1,0,0,1.5h6.47a.75.75,0,1,0,0-1.5Z",
    transform: "translate(-218.537 -199.612)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M422.079,417.6h-6.47a.75.75,0,1,0,0,1.5h6.47a.75.75,0,1,0,0-1.5Z",
    transform: "translate(-218.537 -243.542)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M207,160.271h-3.9v-1.241a.75.75,0,0,0-.75-.75h-2.638v-.737a2.5,2.5,0,1,0-4.992,0v.737h-2.638a.75.75,0,0,0-.75.75v1.241h-3.9a.751.751,0,0,0-.75.75v9.07h1.5v-8.32h3.151v1.243a.751.751,0,0,0,.75.75h10.269a.751.751,0,0,0,.75-.75v-1.243h3.151v23.773H195.678V171.379a.75.75,0,0,0-.75-.75H180.012a.75.75,0,0,0-.75.75V186.3a.75.75,0,0,0,.75.75H207a.751.751,0,0,0,.75-.75V161.022a.751.751,0,0,0-.75-.75Zm-10.78-2.728a1,1,0,1,1,1.991,0v.737h-1.991Zm5.38,4.722h-8.768v-2.484H201.6Zm-16.148,9.864h3.978v3.26l-.416-.3a.535.535,0,0,0-.621,0l-.952.678-.952-.678a.535.535,0,0,0-.622,0l-.416.3Zm-4.693,0h3.621v4.3a.536.536,0,0,0,.847.436l.952-.678.952.678a.535.535,0,0,0,.622,0l.952-.678.952.678a.536.536,0,0,0,.847-.436v-4.3h3.674v13.416H180.762Z",
    transform: "translate(0)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M210.506,527.42h-1.844a.536.536,0,0,0-.536.536V529.8a.536.536,0,0,0,.536.536h1.844a.536.536,0,0,0,.536-.536v-1.844A.535.535,0,0,0,210.506,527.42Zm-.536,1.844H209.2v-.772h.772Z",
    transform: "translate(-26.775 -345.41)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M261.77,530.337a.536.536,0,0,0,.536-.536v-1.844a.536.536,0,0,0-.536-.536h-1.844a.536.536,0,0,0-.536.536V529.8a.536.536,0,0,0,.536.536Zm-1.308-1.844h.772v.772h-.772Z",
    transform: "translate(-74.327 -345.412)",
    fill: "#ff7200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPod);
export default __webpack_public_path__ + "static/media/TotalPOD.8d9e0e0a17c4074a43a18bc5f3f5ea57.svg";
export { ForwardRef as ReactComponent };